import { render, staticRenderFns } from "./TopHabilidades.vue?vue&type=template&id=35758fd3&lang=pug"
import script from "./TopHabilidades.vue?vue&type=script&lang=js"
export * from "./TopHabilidades.vue?vue&type=script&lang=js"
import style0 from "./TopHabilidades.vue?vue&type=style&index=0&id=35758fd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports